/* Keep the chat launcher away from purchase and consent controls. */
(()=>{'use strict';
 let queued=false;
 const visible=e=>!!e&&e.getBoundingClientRect().width>0&&e.getBoundingClientRect().height>0&&getComputedStyle(e).display!=='none'&&getComputedStyle(e).visibility!=='hidden';
 function update(){queued=false;
  const selectors='main button[name="add"],sticky-add-to-cart .sticky-add-to-cart__button,button[name="checkout"]';
  const purchase=Array.from(document.querySelectorAll(selectors)).some(e=>{if(!visible(e))return false;const r=e.getBoundingClientRect();return r.top<innerHeight&&r.bottom>0;});
  const overlay=Array.from(document.querySelectorAll('#shopify-pc__banner,#shopify-pc__prefs,dialog[open],#kwp-overlay.kwp-on')).some(visible);
  document.body.classList.toggle('k-purchase-visible',purchase);
  document.body.classList.toggle('k-ui-overlay',overlay);
 }
 function schedule(){if(!queued){queued=true;requestAnimationFrame(update);}}
 document.addEventListener('scroll',schedule,{capture:true,passive:true});window.addEventListener('resize',schedule,{passive:true});
 document.addEventListener('visitorConsentCollected',schedule);document.addEventListener('cart:update',schedule);
 new MutationObserver(schedule).observe(document.documentElement,{childList:true,subtree:true});
 setInterval(schedule,1500);update();
})();
